import React, { useState, useEffect } from 'react';
import { Select, Input } from 'antd';
import { dashboardApi } from '../../services/dashboardApi';

const { Option } = Select;

const LabelValueSelector = ({ labelName, value, onChange, metric }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('select'); // 'select' or 'input'

  useEffect(() => {
    if (labelName) {
      loadValues();
    } else {
      setOptions([]);
    }
  }, [labelName, metric]);

  const loadValues = async () => {
    if (!labelName) return;

    setLoading(true);
    try {
      const response = await dashboardApi.getLabelValues(labelName);
      
      if (response.success && response.data?.values) {
        const values = response.data.values;
        
        // If too many values (>100), use text input instead
        if (values.length > 100) {
          setMode('input');
          setOptions([]);
        } else {
          setMode('select');
          setOptions(values);
        }
      }
    } catch (error) {
      console.error('Failed to load label values:', error);
      // Fallback to text input on error
      setMode('input');
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  // Allow switching between modes
  const handleModeToggle = () => {
    setMode(prev => prev === 'select' ? 'input' : 'select');
  };

  if (mode === 'input' || !labelName) {
    return (
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="value or $variable"
        style={{ flex: 1 }}
        addonAfter={
          options.length > 0 && (
            <span 
              onClick={handleModeToggle}
              style={{ cursor: 'pointer' }}
              title="Switch to dropdown"
            >
              ▼
            </span>
          )
        }
      />
    );
  }

  return (
    <Select
      value={value}
      onChange={onChange}
      style={{ flex: 1 }}
      placeholder={loading ? 'Loading...' : 'Select value or type $variable'}
      loading={loading}
      showSearch
      allowClear
      mode="tags"
      maxTagCount={1}
      filterOption={(input, option) =>
        option.children.toLowerCase().includes(input.toLowerCase())
      }
      dropdownRender={(menu) => (
        <>
          {menu}
          <div 
            style={{ 
              padding: '8px', 
              borderTop: '1px solid #f0f0f0',
              cursor: 'pointer',
              textAlign: 'center',
              color: '#1890ff'
            }}
            onClick={handleModeToggle}
          >
            Switch to text input
          </div>
        </>
      )}
    >
      {options.map(opt => (
        <Option key={opt} value={opt}>{opt}</Option>
      ))}
    </Select>
  );
};

export default LabelValueSelector;